import React, { useEffect, useState } from 'react';
import Logo from '../common/Logo';
import { Link, withRouter } from 'react-router-dom';
import { commonLogout, LOCAL_STORAGE_VAR, KYC_STATUS } from '../../constants/Common';
import IntlMessages from '../../util/IntlMessages';
import { getNextBidData } from '../../services/util';
import UtilService from '../../services/util';
import OpenNotification from '../common/CommonButton/OpenNotification';
import ScrollArea from 'react-scrollbar';

const SidebarHeader = (props) => {
  const [bidDiamond, setBidDiamond] = useState('');
  const crnt_url = window.location.pathname;
  useEffect(() => {
    getBidConfig();
  }, [crnt_url]);

  const getBidConfig = async () => {
    let nextBid = await getNextBidData()
      .then()
      .catch(() => undefined);
    setBidDiamond(nextBid ? nextBid : {});
  };

  let actionPerform = true;
  let messagePerform = true;
  const userData = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);
  const userTypeCheck = userData?.type === 4 || userData?.type === 10;
  if (userTypeCheck) {
    if (!userData?.account?.isKycUploaded) {
      actionPerform = false;
      messagePerform = 'Please upload your KYC documents to access this functionality.';
    } else if (userData?.account?.isApproved === KYC_STATUS.PENDING) {
      actionPerform = false;
      messagePerform = 'You will access this functionality once your KYC is approved.';
    } else if (userData?.account?.isApproved === KYC_STATUS.REJECT) {
      actionPerform = false;
      messagePerform = 'Your KYC is rejected. Please upload your KYC again with right information.';
    }
  }
  return (
    <div className="sidebarHeader">
      <div className="sidebarLogo">
        <Logo />
      </div>
      <ScrollArea
        speed={0.8}
        className="settingLeftScroll area sideBarScroll"
        contentClassName="content"
        smoothScrolling={Boolean}
        horizontal={false}
      >
        <div className="sidebarMenuList">
          <ul>
            <li className={`menuItem ${crnt_url === `/dashboard` && `active`}`}>
              <Link to="/">
                {crnt_url === `/dashboard` ? (
                  <img alt="" src={require('../../assets/svg/sidebar/Dashboard-color.svg')} />
                ) : (
                  <img alt="" src={require('../../assets/svg/sidebar/Dashboard.svg')} />
                )}
                <span>
                  <IntlMessages id="app.dashboard" />
                </span>
              </Link>
            </li>
            <li className={`menuItem ${crnt_url === `/diamond-search` && `active`}`}>
              <Link to="/diamond-search">
                {crnt_url === `/diamond-search` ? (
                  <img alt="" src={require('../../assets/svg/sidebar/search-color.svg')} />
                ) : (
                  <img alt="" src={require('../../assets/svg/sidebar/search.svg')} />
                )}
                <span>
                  <IntlMessages id="app.Search" />
                </span>
              </Link>
            </li>

            <li className={`menuItem ${crnt_url === `/best-buy` && `active`}`}>
              <a
                onClick={() => {
                  if (!actionPerform) {
                    OpenNotification({
                      type: 'error',
                      title: messagePerform,
                    });
                  } else {
                    props.history.push('/best-buy');
                  }
                }}
              >
                {crnt_url === `/best-buy` ? (
                  <img alt="" src={require('../../assets/svg/sidebar/diamond-color.svg')} />
                ) : (
                  <img alt="" src={require('../../assets/svg/sidebar/diamond.svg')} />
                )}
                <span>
                  <IntlMessages id="app.stoneOfTheDay" />
                </span>
              </a>
            </li>
            <li className={`menuItem ${crnt_url === `/featured-stone` && `active`}`}>
              <a
                onClick={() => {
                  if (!actionPerform) {
                    OpenNotification({
                      type: 'error',
                      title: messagePerform,
                    });
                  } else {
                    props.history.push('/featured-stone');
                  }
                }}
              >
                {crnt_url === `/featured-stone` ? (
                  <img alt="" src={require('../../assets/svg/sidebar/diamond-color.svg')} />
                ) : (
                  <img alt="" src={require('../../assets/svg/sidebar/diamond.svg')} />
                )}
                <span>
                  <IntlMessages id="app.featuredStoneDashboard" />
                </span>
              </a>
            </li>
            <li className={`menuItem ${crnt_url === `/new-arrivals` && `active`}`}>
              <a
                onClick={() => {
                  if (!actionPerform) {
                    OpenNotification({
                      type: 'error',
                      title: messagePerform,
                    });
                  } else {
                    props.history.push('/new-arrivals');
                  }
                }}
              >
                {crnt_url === `/new-arrivals` ? (
                  <img alt="" src={require('../../assets/svg/sidebar/new-arrivals-color.svg')} />
                ) : (
                  <img alt="" src={require('../../assets/svg/sidebar/new-arrivals.svg')} />
                )}
                <span>
                  <IntlMessages id="app.NewArrivals" />
                </span>
              </a>
            </li>
            <li className={`menuItem ${crnt_url === `/search-bid-diamond` && `active`}`}>
              <a
                onClick={() => {
                  if (!actionPerform) {
                    OpenNotification({
                      type: 'error',
                      title: messagePerform,
                    });
                  } else {
                    props.history.push('/search-bid-diamond');
                  }
                }}
              >
                {crnt_url === `/search-bid-diamond` ? (
                  <img alt="" src={require('../../assets/svg/sidebar/ubs-active.svg')} />
                ) : (
                  <img alt="" src={require('../../assets/svg/sidebar/ubs.svg')} />
                )}
                <span>Bid</span>
                <div className={JSON.stringify(bidDiamond) !== '{}' ? 'ribbon active' : 'ribbon inactive'}>
                  <span className="bidActive">{JSON.stringify(bidDiamond) !== '{}' ? 'Active' : 'Inactive'}</span>
                </div>
              </a>
            </li>
            <li className={`menuItem ${crnt_url === `/account/watchlist` && `active`}`}>
              <Link to="/account/watchlist">
                {crnt_url === `/account/watchlist` ? (
                  <img alt="" src={require('../../assets/svg/Header/user-color.svg')} />
                ) : (
                  <img alt="" src={require('../../assets/svg/Header/user.svg')} />
                )}
                <span>
                  <IntlMessages id="app.myAccount" />
                </span>
              </Link>
            </li>
            {/* <li>
                                    <Link to="/">
                                    <img src={require("../../assets/svg/Header/notification.svg")}/>
                                    <span>Notification</span></Link>
                                </li> */}
          </ul>
        </div>
      </ScrollArea>

      <div className="sidebarMenuList sidebarListBottom">
        <ul>
          <li onClick={() => commonLogout()}>
            <Link to="/">
              <img alt="" src={require('../../assets/svg/Header/logout.svg')} />
              <span>
                <IntlMessages id="app.Logout" />
              </span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default withRouter(SidebarHeader);
